import { createContext, FC, PropsWithChildren, useContext } from 'react';

import { Brand } from '../../themes';

type DesignSystem = {
  brand: Brand;
  isApp: boolean;
};

const Context = createContext<DesignSystem | undefined>(undefined);

type Props = PropsWithChildren<{
  brand: Brand;
  isApp?: boolean;
}>;

export const DesignSystemProvider: FC<Props> = ({
  children,
  brand,
  isApp = false,
}) => {
  return (
    <Context.Provider value={{ brand, isApp }}>{children}</Context.Provider>
  );
};

export const useDesignSystem = (): DesignSystem => {
  const context = useContext(Context);

  if (context === undefined) {
    throw new Error(
      'useDesignSystem must be used within a DesignSystemProvider',
    );
  }

  return context;
};
